import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
//import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { environment} from '../../environments/environment';

@Injectable()
export class ContentAuthoringService {
 adminLoginData:any = JSON.parse(localStorage.getItem('adminLoginPass') || '[]');
 private BASE_URL: string = environment.API_URL;
 private BASE_URL_PHP: string = environment.PHP_API;
 
  private errorData: any = {};
  data: any = "";
  contentAuth = "";
  username: string = this.adminLoginData.email; password: string = this.adminLoginData.pass;
 // username: string = "shubham.j@unikove.com"; password: string = "shubh@123";
  withCredentials: boolean = true;
authorizationData: any = 'Basic ' + btoa(this.username + ':' + this.password);
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": this.authorizationData,
    }),
  };
  httpOptions1 = {
     headers: new HttpHeaders({ 'Authorization': this.authorizationData})
   };
   httpOptions2 = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData,'loginToken':''})
  };
  
  constructor(private http: HttpClient, private router: Router) {}

  assignCourseDetails(userId:number,courseId:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/assgined-course-details',{ "user_id" : userId,"course_id":courseId},this.httpOptions2);
  }

  subModuleStartView(user_id:number,course_id:any,module_id:any,submodule_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/submodule/start-date',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id},this.httpOptions2);
    }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any): Observable<any>{
      return this.http.post(this.BASE_URL+'user/save-assesment',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id, "request_status":request_status, },this.httpOptions2);
     }

  /***********get content authoring listing data ******/
  public getContentAuthList(searchText: any, is_active: any, capsules_status: any, order_by: any, order: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'search/content/capsule', { "searchText": searchText, "is_active": is_active, "capsules_status": capsules_status, "order_by": order_by, "order": order }, this.httpOptions);
  }
  /***********get user data by user Id ******/
  public getUserDataById(userId: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'search/content/capsule', { "userId": userId,  }, this.httpOptions);
  }
  /***********Delete capsule by id ******/
  public deletesCapsule(content_capsule_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'delete/content-capsule', { "content_capsule_id": content_capsule_id }, this.httpOptions);
  }
  /******delete organisation *****/
  public deletesOrg(org_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'org/delete', { "org_id": org_id }, this.httpOptions);
  }
  /******get detail organisation *****/
  public detailOrg(org_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'org/get/details', { "org_id": org_id }, this.httpOptions);
  }
  /***********Change status in active and deactive ******/
  public changeIsActiveVal(content_capsule_id: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'change/content/capsule/active/status', { "content_capsule_id": content_capsule_id, "is_active": is_active }, this.httpOptions);
  }
  /*********** get content authoring data******/
  public getContentAuthDetails(content_capsule_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'content/capsule/details', { "content_capsule_id": content_capsule_id }, this.httpOptions);
  }
  /*********** get user all users data******/
  public getUserList(searchText: any, is_active: any, order_by: any, order: any, filter_by: any, user_type:number): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/customer/list', { "searchText": searchText, "is_active": is_active, "order_by": order_by, "order": order, "filter_by": filter_by,"typeUser":user_type }, this.httpOptions);
  }
  public getContentAuthListOwner(): Observable<any> {
    return this.http.get(this.BASE_URL + 'owner/world');
  }
  public getContentAuthListHello(): Observable<any> {
    return this.http.post(this.BASE_URL + 'hello/world', {});
  }
  public publishCapsule(content_capsule_id:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'publish/content-capsule', { "content_capsule_id": content_capsule_id }, this.httpOptions);
  }
  getContentAuthOld(searchText: any, is_active: any) {
    return this.http.post<any>(`${this.BASE_URL}search/content/capsule`, { "searchText": searchText, "is_active": is_active }, this.httpOptions)
      .pipe(map(contentAuth => {
        if (contentAuth) {
          return contentAuth.json();
        }
      }),
        catchError(this.handleError)
      );
  }
  /*******create content authoring */
  upload(formData: any,page:any) {
    if(page == 'create'){
      return this.http.post<any>(`${this.BASE_URL}create/content/capsule`, formData, this.httpOptions)
      .pipe(map(contentAuth => {
        if (contentAuth) {
          return contentAuth;
        }
      }),
        catchError(this.handleError)
      );
    }else{
      return this.http.post<any>(`${this.BASE_URL}edit/content/capsule`, formData, this.httpOptions)
      .pipe(map(contentAuth => {
        if (contentAuth) {
          return contentAuth;
        }
      }),
        catchError(this.handleError)
      );
    }
  }
  createUser(userFormData: any) {
    return this.http.post<any>(`${this.BASE_URL}user/create`, userFormData, this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
  }
  generateOtp(postJson: any) {
    return this.http.post<any>(`${this.BASE_URL}user/create/otp`, postJson, this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
  }

  editUser(userFormData: any){
    return this.http.post<any>(`${this.BASE_URL}user/update`, userFormData, this.httpOptions)
    .pipe(map(data => {
      if (data) {
        return data;
      }
    }),
      catchError(this.handleError)
    );
  }
  public getOrganisationList(searchText: any, is_active: any,order_by:any,order:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'organisation/list', { "searchText": searchText, "is_active": is_active,"order_by" : order_by,"order" : order }, this.httpOptions);
  }
  

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };
    return throwError(this.errorData);
  }
  // Anjali Start
  createOrgUser(orgFormData: any) {
    return this.http.post<any>(`${this.BASE_URL}create/organisation`, orgFormData, this.httpOptions)
      .pipe(map(data => {
        if (data) {
          return data;
        }
      }),
        catchError(this.handleError)
      );
  }

   /***********Change status in active and deactive ******/
   public changeOrgIsActiveVal(org_id: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'change/organisation/active/status', { "organisation_id": org_id, "is_active": is_active }, this.httpOptions);
  }
  public getUserDetail(userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/user_details', { "user_id": userId}, this.httpOptions);
  }
  assignCourses(status:number,user_id:number): Observable<any>{
    return this.http.post(this.BASE_URL+'user/assigned/courses',{ "status" : status,"user_id":user_id},this.httpOptions2);
   }

   /***********Change user status in active and deactive ******/
   public changeUserIsActiveVal(userId: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/updatestatus', { "user_id": userId, "status": is_active }, this.httpOptions);
  }

  public getCoursesList(userId: any, order: any, order_by: any,searchText:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'list/courses', { "user_id":userId, "order_by": order_by, "order": order,"search":searchText}, this.httpOptions);
  }
  public getAdminUserList(searchText: any, is_active: any, order_by: any, order: any, filter_by: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/customer/list', { "searchText": searchText, "is_active": is_active, "order_by": order_by, "order": order, "filter_by": filter_by }, this.httpOptions);
  }
  public changeAdminUserIsActiveVal(userId: any, is_active: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/updatestatus', { "user_id": userId, "status": is_active }, this.httpOptions);
  }
  public getAdminUserDetail(userId:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/user_details', { "user_id": userId}, this.httpOptions);
  }
  editAdminUser(userFormData: any){
    return this.http.post<any>(`${this.BASE_URL}user/update`, userFormData, this.httpOptions)
    .pipe(map(data => {
      if (data) {
        return data;
      }
    }),
      catchError(this.handleError)
    );
  }
  public getUserCourseList(user_id:any,searchText:any, order:any, order_by:any): Observable<any> {
    //return this.http.post(this.BASE_URL_PHP + 'course-list.php', { "user_id": user_id,  "search":searchText, "order": order, "order_by": order_by}, this.httpOptions1);
    return this.http.post(this.BASE_URL +'user/course/list', { "user_id": user_id,  "search":searchText, "order": order, "order_by": order_by}, this.httpOptions1);
  }
  public getActivateDeactiveCourseList(capsuleId:any, searchText:any, order:any, order_by:any, isActive:any): Observable<any> {
    //return this.http.post(this.BASE_URL_PHP + 'course-list.php', { "capsuleId": capsuleId, "search": searchText, "order": order, "order_by": order_by,"is_active":isActive}, this.httpOptions1);
    return this.http.post(this.BASE_URL + 'user/course/capsule/list', { "capsuleId": capsuleId, "search": searchText, "order": order, "order_by": order_by,"is_active":isActive}, this.httpOptions1);
  }
  ViewCoursesAcceptReject(user_id:number,course_id:any,assessment_id:any, request_status:any,reject_reason:any ): Observable<any>{
    return this.http.post(this.BASE_URL+'user/save-assesment',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id, "request_status":request_status, "reject_reason":reject_reason},this.httpOptions2);
   }
  acceptRejectAssmnt(user_id:number,assessment_id:any, request_status:any,reject_reason:any ): Observable<any>{
    return this.http.post(this.BASE_URL+'reject/accept/assessment',{ "user_id" : user_id,"assessment_id":assessment_id, "request_status":request_status, "reject_reason":reject_reason},this.httpOptions2);
   }
   public getResetRqstList(searchText: any, order_by: any, order: any, status: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'view/users-course-progress', { "search": searchText, "order_by": order_by, "order": order, "status": status }, this.httpOptions);
  }
  //Anjali end
  public deleteUsers(userId: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'user/delete', { "user_id": userId}, this.httpOptions);
  }
  public editOrg(organisation_id: any,organisation_name:any,organisation_type:any, validity:any, created_by:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'edit/organisation', { "organisation_id": organisation_id,"organisation_name":organisation_name,'organisation_type':organisation_type,'validity':validity,"created_by":created_by}, this.httpOptions);
  }
  public create_user_status(email: any,user_id:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'create/user/status', { "email": email,"user_id": user_id }, this.httpOptions);
  }
  public create_admin_asuser(email: any,user_id:any,organisation_id:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'create/admin/asuser', { "email": email,"user_id": user_id ,"organisation_id":organisation_id}, this.httpOptions);
  }
  public getTicketData(searchText: any, is_active: any, order_by: any, order: any, status:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'ad/show/contact', { "searchText": searchText, "is_active": is_active, "order_by": order_by, "order": order, "status": status }, this.httpOptions);
  }
  markResolved(postJson:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'update/contact/status', JSON.stringify(postJson), this.httpOptions);
  }
  ticketDetail(postJson:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'view/contact/details', JSON.stringify(postJson), this.httpOptions);
  }
  ticketCountDetail(postJson:any): Observable<any> {
    return this.http.post(this.BASE_URL + 'ticket/count/update', JSON.stringify(postJson), this.httpOptions);
  }
  public deleteTickets(ticket_id: any): Observable<any> {
    return this.http.post(this.BASE_URL + 'delete/contact/ticket', { "ticket_id": ticket_id }, this.httpOptions);
  }
}
